import Form from "Clutch/Atoms/Form";
import { CalculateTireSpacing, CalculateFinalTireSize } from "./logic";
import { useState } from "react";
import Typography from "Clutch/Atoms/Typography";
import Button from "Clutch/Molecules/Button";
import ContextualError from "../common/contextualError";
import FormGroup from "../common/formGroup";


const FinalTireSizeByWheel = () => {

    const [wheelDiameter, setWheelDiameter] = useState("");
    const [wheelOffset, setWheelOffset] = useState("");
    const [desiredTireWidth, setDesiredTireWidth] = useState("");
    const [sidewallHeight, setSidewallHeight] = useState("");

    const [result, setResult] = useState({
        isValid: false,
        errors: [],
        tireSpacingResult: null,
        finalTireSizeImperial: null,
        finalTireSizeMetric: null,
    });

    const CalculateInternalTireSpacing = (e) => {
        e.preventDefault()
        const tireSpacingResult = CalculateTireSpacing({ wheelOffset, desiredTireWidth });
        setResult(tireSpacingResult);
    }

    const CalculateInternalFinalTireSize = (e) => {
        e.preventDefault()
        const finalTireSize = CalculateFinalTireSize({ wheelDiameter, sidewallHeight, desiredTireWidth });
        setResult(finalTireSize)
    }

    const shouldTireSpacingBeDisabled = (wheelOffset === '' || desiredTireWidth === '');
    const shouldFinalTireSizeButtonBeDisabled = (wheelDiameter === '' || sidewallHeight === '')

    const wheelOffsetError = result.errors.find(x => x.id == 'wheelOffset');
    const desiredTireWidthError = result.errors.find(x => x.id == 'desiredTireWidth');
    const wheelDiameterError = result.errors.find(x => x.id == 'wheelDiameter');
    const tireSpacingError = result.errors.find(x => x.id == 'tireSpacing');
    const sidewallHeightError = result.errors.find(x => x.id == 'sidewallHeight');

    return <Form>
        <FormGroup>
            <Form.Textbox
                fill
                id={'wheelOffset'}
                label={`Wheel Offset (millimeters)`}
                intent={wheelOffsetError ? 'negative' : null}
                placeholder={0}
                onChange={(e) => { setWheelOffset(e.target.value) }}
                value={wheelOffset}
                type={'number'}
                step="any"
            />
            <ContextualError error={wheelOffsetError} />
        </FormGroup>
        <FormGroup>
            <Form.Textbox
                fill
                id={'desiredTireWidth'}
                label={`Tire Width (inches)`}
                intent={desiredTireWidthError ? 'negative' : null}
                placeholder={0}
                onChange={(e) => { setDesiredTireWidth(e.target.value) }}
                value={desiredTireWidth}
                type={'number'}
                step="any"
            />
            <ContextualError error={desiredTireWidthError} />
        </FormGroup>

        <FormGroup>
            <Button disabled={shouldTireSpacingBeDisabled} intent={'action'} size={'small'} event={{}} text={"Calculate Tire Spacing"} type={'button'} onClick={CalculateInternalTireSpacing}></Button>
        </FormGroup>
        < br />
        <FormGroup>
            <Form.Textbox
                fill
                id={'tireSpacing'}
                label={`Tire Spacing (millimeters)`}
                intent={tireSpacingError ? 'negative' : null}
                value={result.tireSpacingResult}
                type={'number'}
                readonly={'true'}
                step="any"
                disabled="true"
            />
            <ContextualError error={tireSpacingError} />
        </FormGroup>
        <FormGroup>
            <Form.Textbox
                fill
                id={'wheelDiameter'}
                label={`Wheel Diameter (inches)`}
                intent={wheelDiameterError ? 'negative' : null}
                placeholder={0}
                onChange={(e) => { setWheelDiameter(e.target.value) }}
                value={wheelDiameter}
                type={'number'}
                step="any"
            />
            <ContextualError error={wheelDiameterError} />
        </FormGroup>
        <FormGroup>
            <Form.Textbox
                fill
                id={'sidewallHeight'}
                label={`Sidewall Height (inches)`}
                intent={sidewallHeightError ? 'negative' : null}
                placeholder={0}
                onChange={(e) => { setSidewallHeight(e.target.value) }}
                value={sidewallHeight}
                type={'number'}
                step="any"
            />
            <ContextualError error={sidewallHeightError} />
        </FormGroup>
        <FormGroup>
            <Button disabled={shouldFinalTireSizeButtonBeDisabled} intent={'action'} size={'small'} event={{}} text={"Calculate Final Tire Size"} type={'button'} onClick={CalculateInternalFinalTireSize}></Button>
        </FormGroup>
        <FormGroup>
            {result.isValid ? <Typography as={'span'} size={1.25} font={'bold'}>{result.finalTireSizeMetric}</Typography> : false}
        </FormGroup>
        <FormGroup>
            {result.isValid ? <Typography as={'span'} size={1.25} font={'bold'}>{result.finalTireSizeImperial}</Typography> : false}
        </FormGroup>
    </Form>
}

export default FinalTireSizeByWheel